var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRoles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 7.8335H14.6663V9.16683H9.99967V7.8335ZM10.6663 10.5002H14.6663V11.8335H10.6663V10.5002ZM9.33301 5.16683H14.6663V6.50016H9.33301V5.16683ZM2.66634 13.1668H9.33301V12.5002C9.33301 10.6622 7.83767 9.16683 5.99967 9.16683H4.66634C2.82834 9.16683 1.33301 10.6622 1.33301 12.5002V13.1668H2.66634ZM5.33301 8.50016C6.66301 8.50016 7.66634 7.49683 7.66634 6.16683C7.66634 4.83683 6.66301 3.8335 5.33301 3.8335C4.00301 3.8335 2.99967 4.83683 2.99967 6.16683C2.99967 7.49683 4.00301 8.50016 5.33301 8.50016Z",
    fill: "#1F242E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRoles);
export default __webpack_public_path__ + "static/media/user_roles.bdf2c37f4b5224c802e1fc0d960bf4a6.svg";
export { ForwardRef as ReactComponent };